import {
  SPI,
  FormFieldWidget,
  ViewType,
  ModelFieldType,
  BaseFieldOptions,
  FormMultiEnumFieldWidget,
  Widget,
  CallChaining
} from '@kunlun/dependencies';

const genToken = (name: string, model = ['deli.aries.seller.SellerDistributorTradeOrder']) => {
  return {
    viewType: ViewType.Search,
    name,
    model,
    ttype: ModelFieldType.Enum,
    multi: false
  } as BaseFieldOptions;
};

@SPI.ClassFactory(
  FormFieldWidget.Token(
    genToken('orderStatus', [
      'deli.aries.seller.SellerDistributionTradeOrderDetail',
      'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
    ])
  )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('orderType', [
            'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
        ])
    )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('bizType', [
            'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
        ])
    )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('auditStatus', [
            'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
        ])
    )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('deliveryOrderStatus', [
            'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
        ])
    )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('closeStatus', [
            'deli.aries.trade.DeliAriesPlatformBrandStoreTradeOrderDetail'
        ])
    )
)

@SPI.ClassFactory(
  FormFieldWidget.Token(
    genToken('deliveryOrderStatus', [
      'deli.aries.seller.SellerDistributionTradeOrderDetail'
    ])
  )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('reverseStatus', [
          'deli.aries.seller.DeliAriesSellerTradeReverseOrder'
        ])
    )
)
@SPI.ClassFactory(
    FormFieldWidget.Token(
        genToken('returnStatus', [
          'deli.aries.seller.DeliAriesSellerTradeReverseOrder'
        ])
    )
)
@SPI.ClassFactory(FormFieldWidget.Token(genToken('bizType')))
@SPI.ClassFactory(FormFieldWidget.Token(genToken('orderStatus')))
@SPI.ClassFactory(FormFieldWidget.Token(genToken('deliveryOrderStatus')))
@SPI.ClassFactory(FormFieldWidget.Token(genToken('auditStatus')))
@SPI.ClassFactory(FormFieldWidget.Token(genToken('issuingMethodEnum')))
@SPI.ClassFactory(FormFieldWidget.Token(genToken('tmsDeliveryMethod')))
@SPI.ClassFactory(FormFieldWidget.Token(genToken('reverseStatus')))
@SPI.ClassFactory(FormFieldWidget.Token(genToken('returnStatus')))
@SPI.ClassFactory(
  FormFieldWidget.Token(
    genToken('activityStatus', [
      'deli.aries.seller.DeliAriesSellerPromotionPlan',
      'deli.platform.promotion.DeliAriesPlatformPromotionPlan',
      'deli.platform.promotion.DeliAriesPlatformPromotionReginPlan'
    ])
  )
)
export class SearchEnumMultiSelectWidget extends FormMultiEnumFieldWidget {
  private currrntPropsName = '';
  public initialize(props) {
    super.initialize(props);
    if (props.name === 'activityStatus') {
      this.currrntPropsName = props.name
    }

    return this;
  }
  /**
   * 挂载时
   * @protected
   */
  @Widget.Reactive()
  @Widget.Inject()
  protected mountedCallChaining: CallChaining | undefined;
  protected $$mounted() {
    super.$$mounted();
    this.mountedCallChaining?.hook(
      this.path,
      async () => {
        if (this.currrntPropsName === 'activityStatus' && !this.value) {
          this.change(['PROCESSING', 'PREPARE','WAIT_SUBMIT','WAIT_RELEASE']);
        }
        if (typeof this.value === 'string') {
          this.change((this.value as string).split(','))
        }
      },
      CallChaining.MIN_PRIORITY
    );
  }

}
